import { call, put, takeEvery } from 'redux-saga/effects';
import { FETCH_WALLET_TXNS } from "../actionTypes";
import { apiCall } from "../../services";
import { history } from "../../utils/history";
import {  setLoader, removeLoader, fetchWalletTxnsSuccess } from "../actions"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function* fetchWalletTxns(actions) {
	yield put(setLoader());
	const fetchWalletTxnsAction = yield apiCall({ body: {...actions.data},url:'get_wallet_info'});
	
	if (fetchWalletTxnsAction) {
		yield put(removeLoader());
		if(fetchWalletTxnsAction.data.success){
			yield put(fetchWalletTxnsSuccess(fetchWalletTxnsAction.data));
		}else {
			const options = {
				autoClose: 2500,
				hideProgressBar: true,
				position: toast.POSITION.BOTTOM_CENTER,
				closeButton: false,
				draggable: false,
				pauseOnFocusLoss: false,
				closeOnClick: false
			};
			toast.error(fetchWalletTxnsAction.data.msg, options)
		} 
	} 
}
export default function* root() {
  	yield takeEvery(FETCH_WALLET_TXNS, fetchWalletTxns);
}